import type { SearchHistoryEntry } from "~/client/components/search/hooks/useSearchHistory";
import type { CreateSearchFilterSetInput } from "~/client/generated/schema";
import { useCreateSearchFilterSetMutation } from "~/client/generated/schema";

export const buildCreateSearchFilterSetPayloadFromSearchHistoryEntry = (
  entry: SearchHistoryEntry,
): CreateSearchFilterSetInput => {
  return {
    excludeKeywords: entry.excludeKeywords,
    authorUserIds: entry.authorUsers.map((u) => u.id) as Array<string>,
    groupIds: entry.groups.map((g) => g.id) as Array<string>,
    folderIds: entry.folders.map((f) => f.id) as Array<string>,
    dateGte: entry.dateGte,
    isLikedByMe: entry.isLikedByMe,
    resourceTypes: entry.resourceTypes,
    isArchived: entry.isArchived,
  };
};

export const useSaveSearchFilterSet = () => {
  // errorPolicyがデフォルト(none)だとcatch出来ない状況で例外が発生する
  // ref: https://www.apollographql.com/docs/react/data/error-handling/#graphql-error-policies
  const [createSearchFilterSet, { data, loading, error }] = useCreateSearchFilterSetMutation({ errorPolicy: "all" });

  const handleSave = async (input: CreateSearchFilterSetInput) => {
    createSearchFilterSet({ variables: { input } });
  };

  return [handleSave, { data, loading, error }] as const;
};
